export default "__VITE_ASSET__nYtlollY__"